/**
 * Created by Kamil on 26.05.2017.
 */
/**
 * Created by Kamil on 24.05.2017.
 */

import React, {Component} from 'react';
import './SearchFilter.css';

class SearchFilter extends Component {
    constructor(props) {
        super(props);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    handleFilterChange(e) {
        this.props.search(e.target.value);
    }

    render() {
        return (
            <div className="SearchFilter">
                <div className="CategoryFilter-wrap">
                    <form>
                        <div class="form-group">
                            <label className="control-label" for="search">Szukaj</label>
                            <input type="text" className="form-control" name="search" id="search" onChange={this.handleFilterChange}/>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default SearchFilter;


// WEBPACK FOOTER //
// ./src/components/SearchFilter.js